import React, { Component } from "react";

export default class ResetPasswordPage extends Component {
  constructor(props) {
    super(props);
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.split("?")[1]);
    const tokenFromUrl = params.get("token");
    this.state = {
      newPassword: "",
      confirmPassword: "",
      alertMessage: tokenFromUrl ? "" : (
        <div className="callout callout-danger">
          <h6>Ungültiger oder fehlender Token. Bitte fordern Sie einen neuen Link an.</h6>
        </div>
      ),
      isSuccess: false,
      isLoading: false,
      token: tokenFromUrl,
    };
  }

  async submit() {
    if (this.state.isLoading || this.state.isSuccess) return;
    if (!this.state.newPassword || !this.state.confirmPassword) {
      this.setState({
        alertMessage: (
          <div className="callout callout-warning">
            <h6>Bitte füllen Sie alle Felder aus.</h6>
          </div>
        ),
      });
      return;
    }
    if (this.state.newPassword.length < 6) {
      this.setState({
        alertMessage: (
          <div className="callout callout-warning">
            <h6>Das Passwort muss mindestens 6 Zeichen lang sein.</h6>
          </div>
        ),
      });
      return;
    }
    if (this.state.newPassword !== this.state.confirmPassword) {
      this.setState({
        alertMessage: (
          <div className="callout callout-warning">
            <h6>Die Passwörter stimmen nicht überein.</h6>
          </div>
        ),
      });
      return;
    }

    this.setState({ isLoading: true });
    const headers = { "Content-Type": "application/json" };
    const data = { token: this.state.token, newPassword: this.state.newPassword };

    try {
      var response = await fetch(global.api_url + "reset-password", {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data),
      });
      let jsonRes = await response.json();
      if (response.ok) {
        this.setState({
          alertMessage: (
            <div>
              <div className="callout callout-success">
                <h6>Passwort erfolgreich geändert.</h6>
              </div>
              <p className="mt-3 text-center">
                <a href="#/">Zum Login</a>
              </p>
            </div>
          ),
          isSuccess: true,
          isLoading: false,
        });
      } else {
        this.setState({
          alertMessage: (
            <div>
              <div className="callout callout-danger">
                <h6>{jsonRes.message}</h6>
              </div>
              <p className="mt-3 text-center">
                <a href="#/forgot-password">Neuen Link anfordern</a>
              </p>
            </div>
          ),
          isLoading: false,
        });
      }
    } catch (error) {
      this.setState({
        alertMessage: (
          <div>
            <div className="callout callout-danger">
              <h6>Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.</h6>
            </div>
            <p className="mt-3 text-center">
              <a href="#/forgot-password">Neuen Link anfordern</a>
            </p>
          </div>
        ),
        isLoading: false,
      });
    }
  }

  render() {
    return (
      <div className="login-box" style={{ marginLeft: "auto", marginRight: "auto", marginTop: "5rem" }}>
        <div className="login-logo">
          <img src="dist/img/DIVOKA_Logo.png" alt="DiVoKa Logo" />
        </div>
        <div className="card">
          <div className="card-body login-card-body">
            <p className="login-box-msg">Neues Passwort setzen</p>
            <form action="" method="post">
              <div className="input-group mb-3">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Neues Passwort"
                  value={this.state.newPassword}
                  autoFocus
                  disabled={!this.state.token || this.state.isSuccess}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") this.submit();
                  }}
                  onChange={(e) => this.setState({ newPassword: e.target.value })}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-lock"></span>
                  </div>
                </div>
              </div>
              <div className="input-group mb-3">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Passwort bestätigen"
                  value={this.state.confirmPassword}
                  disabled={!this.state.token || this.state.isSuccess}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") this.submit();
                  }}
                  onChange={(e) => this.setState({ confirmPassword: e.target.value })}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-lock"></span>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-auto">
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={this.state.isLoading || !this.state.token || this.state.isSuccess}
                    onClick={() => this.submit()}
                  >
                    {this.state.isLoading ? "Wird gesendet..." : "Passwort ändern"}
                  </button>
                </div>
              </div>
              <div id="alert-message" className="mt-4">
                {this.state.alertMessage}
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}